import { toast } from "react-toastify";

const addNotificationType = 'ADD_NOTIFICATION';
const initialState = { all: [], isLoading: false };

export const actionCreators = {
    addNotification: (content, category) => async (dispatch, getState) =>
    {
        if (getState().notifications.isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }
        else {
            toast(content);
            dispatch({ type: addNotificationType, category, content });
        }
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
  
    if (action.type === addNotificationType) {
        return {
            ...state,
            isLoading: true,
            all: [...state.all, { content: action.content, category: "System", time: Date(Date.now()).toString()}]
        };
    }
    return state;
};